<template>
  <div class="main-layout course">
    <section class="main">
      <!-- <div class="pb-8">
        <div :class="[$vuetify.breakpoint.lgAndUp ? 'display-1': 'headline']">{{ courseTitle }}</div>
      </div> -->
      <UpperDisplay />
      <LowerDisplay />
    </section>
    <CourseList />
    <!-- <Dashboard /> -->
    <!-- <a href="#" class="open-dashboard" v-on:click="toggleDashboard">
      <i class="lni lni-bar-chart"></i>
    </a> -->
    <ImageLecture />
    <!-- <Exam /> -->

    <v-dialog v-model="continueClassroomDialog" persistent max-width="350px">
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title> พบการเข้าเรียนจากอุปกรณ์อื่น </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-btn icon dark @click="onCloseEditProfile">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
        </v-toolbar>
        <v-card-text class="pr-5 pl-5 pb-0">
          <v-container>
            <v-row>
              <v-img
                class="mt-5 mb-5"
                src="@/assets/devices.png"
                max-width="100%"
                contain
                :max-height="128"
                eager
              ></v-img>
              คุณสามารถเข้าเรียนพร้อมกันได้เพียงอุปกรณ์เดียวเท่านั้น,
              ต้องการเรียนต่อหรือไม่ ?
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            :color="$buttonColor"
            flat
            @click="removeDevice(anotherToken)"
            >เรียนต่อ</v-btn
          >
          <v-btn
            class="white--text"
            color="red"
            flat
            @click="removeDevice(myToken)"
            >ปิด</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="waitingClassroomDialog" persistent max-width="350px">
      <v-card>
        <v-card-title>
          พบการเข้าเรียนจากอุปกรณ์อื่น
          <v-spacer></v-spacer>
          <!-- <v-btn color="grey lighten-1 darken-1 pr-0" icon @click="continueClassroomDialog = false">
            <v-icon class="pa-0" size="20px">mdi-close</v-icon>
          </v-btn> -->
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container>
            <v-row>
              โปรดรอการอนุมัติจากอุปกรณ์ดังกล่าว หรือรอประมาณ 10 วินาที
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            color="red"
            flat
            @click="removeDevice(myToken)"
            >ปิด</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import CourseList from "../../components/classroom/classroomSection.vue";
import UpperDisplay from "../../components/classroom/UpperDisplay.vue";
import LowerDisplay from "../../components/classroom/LowerDisplay.vue";
import Dashboard from "../../components/classroom/Dashboard.vue";
import Exam from "../../components/classroom/Dialog/Exam.vue";
import ImageLecture from "../../components/classroom/Dialog/Image.vue";
import { mapState } from "vuex";
import firebase from "../../plugins/firebase";
var database = firebase.database();

export default {
  name: "classroom",
  components: {
    CourseList,
    UpperDisplay,
    LowerDisplay,
    Dashboard,
    Exam,
    ImageLecture,
  },
  computed: mapState(["hisOnlineCourseID", "courseTitle"]),
  data: () => ({
    onlineUserRef: null,
    connectedRef: null,
    connectionList: [],

    continueClassroomDialog: false,
    waitingClassroomDialog: false,

    myToken: null,
    anotherToken: null,
    isShowWaitingDialog: false,
    time: 0,
  }),
  watch: {
    hisOnlineCourseID(value) {
      const courseId = this.$route.params.id;
      // const userInfo = $cookies.get('user_info');
      const userInfo = Vue.prototype.$userInfo;
      const token = $cookies.get("user_token");

      this.connectionList = [];

      this.onlineUserRef = database
        .ref("/onlineUser")
        .child("user_" + userInfo._id)
        .child(token);

      // connect with local device to check internet connection
      this.connectedRef = database.ref(".info/connected");
      this.connectedRef.on("value", (snap) => {
        if (snap.val() === true) {
          // We're connected (or reconnected)! Do anything here that should happen only if online (or on reconnect)
          this.onlineUserRef.parent.on("child_added", (snapshot) => {
            const valForUser = snapshot.val();
            console.log(valForUser);
            this.connectionList.push(valForUser);

            // var myIndex = this.connectionList.findIndex((user) => user.token == token);
            // console.log(myIndex);
            // console.log(this.connectionList);
            // this.connectionList.forEach(user => {
            //   if (user.token != token) {
            //     console.log("TOKEN", user.token != token);
            //     var myTimeStamp = new Date().getTime() - this.connectionList[myIndex].time;
            //     var targetTimeStamp = new Date().getTime() - user.time;

            //     if (myTimeStamp > targetTimeStamp) {
            //       console.log("TIME", myTimeStamp - targetTimeStamp, myTimeStamp > targetTimeStamp);
            //       console.log("ContinueJoinClassRoomPopup");
            //       // this.showContinueJoinClassRoomPopup(this.connectionList[myIndex].token, user.token);
            //     } else {
            //       console.log("WaitingForJoinClassRoomPopup");
            //       // this.showWaitingForJoinClassRoomPopup(this.connectionList[myIndex].token, user.token);
            //     }
            //   }
            // });
          });
          this.onlineUserRef.parent.on("child_removed", (snapshot) => {
            const valForUser = snapshot.val();

            if (valForUser.token == token) {
              if (this.$route.name == "classroom") {
                // this.$router.replace({
                //   name: "course_detail",
                //   params: {
                //     id: this.$route.params.id,
                //   },
                // });
              }
            } else {
              if (this.isShowWaitingDialog) {
                this.continueClassroomDialog = false;
                this.waitingClassroomDialog = false;
                this.isShowWaitingDialog = false;
              }
            }
          });

          // When I disconnect, remove this device
          this.onlineUserRef.onDisconnect().remove();

          // Add this device to my connections list
          // this value could contain info about the device or a timestamp too
          this.onlineUserRef.set({
            displayName: Vue.prototype.$userInfo.displayName,
            hisOnlineCourseID: this.$store.getters.hisOnlineCourseID,
            id: Vue.prototype.$userInfo._id,
            server: "TULA",
            token: this.$cookies.get("user_token"),
            course: courseId,
            time: Date.now(),
            platform: "Web app",
            device: this.$platformDetect.ua,
            osversion: `${this.$platformDetect.os}`,
            browser: `${this.$browserDetect.meta.name} ${this.$browserDetect.meta.version}`,
          });
        }
      });
    },
  },
  methods: {
    toggleDashboard() {
      this.$store.dispatch("toggleDashboard");
    },
    showContinueJoinClassRoomPopup(myToken, anotherToken) {
      this.connectionList.pop();

      this.myToken = myToken;
      this.anotherToken = anotherToken;
      this.continueClassroomDialog = true;
      this.isShowWaitingDialog = true;
    },
    showWaitingForJoinClassRoomPopup(myToken, anotherToken) {
      this.startCountDown();

      this.myToken = myToken;
      this.anotherToken = anotherToken;
      this.waitingClassroomDialog = true;
      this.isShowWaitingDialog = true;
    },
    removeDevice(token) {
      this.onlineUserRef.parent.child(token).remove();
      this.continueClassroomDialog = false;
      this.waitingClassroomDialog = false;
    },
    startCountDown() {
      this.flushInterval();
      const timeLeft = 10000;
      if (timeLeft > 0) {
        this.countdown = setInterval(async () => {
          this.time -= 1;
          if (this.time === 0) {
            this.removeDevice(this.anotherToken);
            this.waitingClassroomDialog = false;
            this.continueClassroomDialog = false;
          }
        }, 1000);
        this.time = Math.floor(timeLeft / 1000);
      }
    },
    flushInterval() {
      if (this.countdown) {
        clearInterval(this.countdown);
      }
    },
  },
};
</script>

<style lang="scss">
@import "./../../scss/classroom/main-layout.scss";
</style>
